const locale = {
  placeholder: '請選擇時間'
};
export default locale;